import { render } from "./TextBoxRemove.vue?vue&type=template&id=35c66e94"
import script from "./TextBoxRemove.vue?vue&type=script&lang=js"
export * from "./TextBoxRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TextBoxRemove.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35c66e94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35c66e94', __exports__)) {
    api.reload('35c66e94', __exports__)
  }
  
  module.hot.accept("./TextBoxRemove.vue?vue&type=template&id=35c66e94", () => {
    api.rerender('35c66e94', render)
  })

}


export default __exports__